import { createElement } from 'react';

import { looksLikeHtml } from './looks-like-html';
import { sanitizeShippingNotesHtml } from './sanitize-shipping-notes-html';

export type ShippingNotesDisplayElement = 'div' | 'p' | 'span';

export interface ShippingNotesDisplayProps {
    value: string | null | undefined;
    className?: string;
    as?: ShippingNotesDisplayElement;
}

/**
 * Read-only shipping notes: renders HTML when the value looks like markup (after sanitize),
 * otherwise plain text.
 */
export const ShippingNotesDisplay = ({ value, className, as = 'div' }: ShippingNotesDisplayProps) => {
    if (value == null || value === '') {
        return null;
    }

    if (looksLikeHtml(value)) {
        const sanitized = sanitizeShippingNotesHtml(value);
        if (!sanitized) {
            return null;
        }
        return createElement(as, {
            className,
            dangerouslySetInnerHTML: { __html: sanitized }
        });
    }

    return createElement(as, { className }, value);
};
